module.exports = __webpack_public_path__ + "static/img/m-lingshou1.a7a5ea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobileImg/m-lingshou1.png
// module id = /Uak
// module chunks = 10